<template>
    <div class="chart">
        <div class="bar" v-for="(item, index) in value" :key="index" >
            <div class="label" style="max-height:130px;width:200px">{{ item.name }}<br/><img :src="item.logo" style="width:50px;max-width:100%;height:50px;object-fit:contain"/></div>
            <div class="bar-visual"
                 :style="{ height: item.percentage + '%' }" @click="selectMunicipality(item)"></div>
            <div class="value" >{{ item.percentage }}%</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BarChart',
        props:{        
            value: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
           
        }
    }
</script>

<style scoped>
    .chart {
        display: flex;
        align-items: flex-end; /* Align bars to the bottom of the container */
        justify-content: space-evenly;
        height: 400px;
        padding: 20px;
    }

    .bar {
        display: flex;
        flex-direction: column-reverse; /* Reverse stacking order to make bars grow from bottom */
        align-items: center;
        width: 6%;
        text-align: center;
        height:100%;
    }

        .bar .value {
            margin-bottom: 8px;
            font-size: 14px;
            font-weight: bold;
            color: #000
        }

        .bar .bar-visual {
            width: 100%;
            background-color: #00bcd4;
            border-radius: 4px;
            transition: height 0.3s ease-in-out;
        }

        .bar .label {
            margin-top: 8px;
            font-size: 12px;
            color: #000;
        }

    @media screen and (max-width: 768px) {
        .chart {
            flex-wrap: wrap;
            height: auto;
        }

        .bar {
            width: 18%;
            margin-bottom: 20px;
        }
    }
</style>
